// extracted by mini-css-extract-plugin
module.exports = {"button":"index-module_button-3G6SS","hide":"index-module_hide-8MHUs"};